<div class="summary-card">
  <div class="data-row">
    <lib-data-point class="v-margin-group">
      <div class="title">
        <lib-text  color="dark-gray" content="Empresa pagadora"></lib-text>
      </div>
      <div class="value highlight-value">
        <lib-text weight="body" size="s" [content]="empresaPagadora"></lib-text>
      </div>
    </lib-data-point>

    <lib-data-point class="v-margin-group" aligned="right">
      <div class="title">
        <lib-text color="dark-gray" content="Monto neto"></lib-text>
      </div>
      <div class="value">
        <lib-money
          [currency]="currency"
          [amount]="invoice?.netAmount || '0.00'"
        ></lib-money>
      </div>
    </lib-data-point>
  </div>

  <div class="data-row">
    <lib-data-point class="v-margin-group">
      <div class="title">
        <lib-text color="dark-gray" content="Empresa giradora"></lib-text>
      </div>
      <div class="value highlight-value">
        <lib-text weight="body" size="s" [content]="empresaGiradora"></lib-text>
      </div>
    </lib-data-point>

    <lib-data-point class="v-margin-group" aligned="right">
      <div class="title">
        <lib-text color="dark-gray" content="Facturas"></lib-text>
      </div>
      <div class="value">
        <lib-text size="xs" [content]="facturas"></lib-text>
      </div>
    </lib-data-point>
  </div>
</div>

<div class="highlight-band">
  <lib-text color="dark-gray" content="Fecha de pago real"></lib-text>
  <lib-text
    class="highlight-band__value"
    size="s"
    weight="heading"
    [content]="actualPaymentDate ? (actualPaymentDate | formatDate) : placeholder"
  ></lib-text>
</div>

<div class="rows">
  <div class="list-row">
    <lib-text color="dark-gray" content="Fecha de pago pactada"></lib-text>
    <lib-text
      size="xs"
      [content]="paymentDate ? (paymentDate | formatDate) : placeholder"
    ></lib-text>
  </div>

  <div class="list-row">
    <lib-text color="dark-gray" content="Garantía"></lib-text>
    <lib-text size="xs" weight="medium" [content]="garantia"></lib-text>
  </div>

  <div class="list-row">
    <lib-text color="dark-gray" [content]="tcemLabel"></lib-text>
    <lib-text size="xs" weight="medium" [content]="tcem"></lib-text>
  </div>

  <div class="list-row">
    <lib-text color="dark-gray" content="Intereses moratorios"></lib-text>
    <lib-text size="xs" weight="medium" [content]="interesesMoratorios"></lib-text>
  </div>

  <div class="list-row" *ngIf="showFeeAjuste">
    <lib-text color="dark-gray" content="Fee de ajuste"></lib-text>
    <lib-text size="xs" weight="medium" [content]="feeAjuste"></lib-text>
  </div>

  <div class="list-row">
    <lib-text color="dark-gray" content="Costo sin IGV"></lib-text>
    <lib-text size="xs" weight="medium" [content]="costoSinIgv"></lib-text>
  </div>

  <div class="list-row">
    <lib-text color="dark-gray" [content]="comisionFinsmartLabel"></lib-text>
    <lib-text size="xs" weight="medium" [content]="comisionFinsmart"></lib-text>
  </div>

  <div class="list-row">
    <lib-text color="dark-gray" content="Costo de financiamiento"></lib-text>
    <lib-text size="xs" weight="medium" [content]="costoFinanciamiento"></lib-text>
  </div>

  <div class="list-row">
    <lib-text color="dark-gray" content="IGV"></lib-text>
    <lib-text size="xs" weight="medium" [content]="igv"></lib-text>
  </div>

  <div class="list-row">
    <lib-text color="dark-gray" content="Precio total"></lib-text>
    <lib-text size="xs" weight="medium" [content]="precioTotal"></lib-text>
  </div>

  <div class="list-row">
    <lib-text color="dark-gray" content="Devolución"></lib-text>
    <lib-text size="xs" weight="medium" [content]="devolucion"></lib-text>
  </div>

  <div class="list-row">
    <lib-text color="dark-gray" content="Configuración de facturación"></lib-text>
    <lib-text size="xs" weight="medium" class="list-row__config" [content]="invoicingConfigurationLabel"></lib-text>
  </div>
</div>
